import { c as _c } from "react/compiler-runtime";
import { ArrowLeft, Bell, Loader2 } from "lucide-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router";
import { useMarkNotificationRead, useNotificationDetail } from "@/api/use-notifications";
import { resolveBuyerNotificationAction } from "@/lib/notification-action";
import { useProfile } from "@/store/profile";
import { Button } from "@osmix/ui/button";
export function NotificationDetailPage() {
  const $ = _c(91);
  const {
    t
  } = useTranslation();
  const {
    id: t0
  } = useParams();
  const id = t0 === undefined ? "" : t0;
  const user = useProfile(_temp);
  const token = useProfile(_temp2);
  const detail = useNotificationDetail(id);
  const {
    mutate: markRead
  } = useMarkNotificationRead();
  let t1;
  let t2;
  if ($[0] !== detail.data || $[1] !== markRead) {
    t1 = () => {
      if (detail.data && !detail.data.readAt) {
        markRead(detail.data.id);
      }
    };
    t2 = [detail.data, markRead];
    $[0] = detail.data;
    $[1] = markRead;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!token || !user) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Bell className="size-9 text-osmix-tangelo" aria-hidden="true" />;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t) {
      t4 = t("notifications.signInTitle");
      $[5] = t;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== t4) {
      t5 = <h1 className="type-h1-bold">{t4}</h1>;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    let t6;
    if ($[9] !== t) {
      t6 = t("notifications.signInHint");
      $[9] = t;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    let t7;
    if ($[11] !== t6) {
      t7 = <p className="mt-2 type-body1 text-osmix-text-2">{t6}</p>;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== t5 || $[14] !== t7) {
      t8 = <div>{t5}{t7}</div>;
      $[13] = t5;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] !== t) {
      t9 = t("notifications.signIn");
      $[16] = t;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    let t10;
    if ($[18] !== t9) {
      t10 = <Button variant="osmix-filled" size="pill" asChild={true}><Link to="/profile">{t9}</Link></Button>;
      $[18] = t9;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    let t11;
    if ($[20] !== t10 || $[21] !== t8) {
      t11 = <div className="mx-auto flex min-h-[420px] max-w-lg flex-col items-center justify-center gap-5 rounded-3xl bg-card p-8 text-center shadow-block">{t3}{t8}{t10}</div>;
      $[20] = t10;
      $[21] = t8;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    return t11;
  }
  if (detail.isPending) {
    let t3;
    if ($[23] !== t) {
      t3 = t("notifications.loading");
      $[23] = t;
      $[24] = t3;
    } else {
      t3 = $[24];
    }
    let t4;
    if ($[25] !== t3) {
      t4 = <div className="grid min-h-64 place-items-center"><Loader2 className="size-6 animate-spin text-osmix-icon" aria-label={t3} /></div>;
      $[25] = t3;
      $[26] = t4;
    } else {
      t4 = $[26];
    }
    return t4;
  }
  if (detail.isError || !detail.data) {
    let t3;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Bell className="size-8 text-osmix-icon" aria-hidden="true" />;
      $[27] = t3;
    } else {
      t3 = $[27];
    }
    let t4;
    if ($[28] !== t) {
      t4 = t("notifications.unavailable");
      $[28] = t;
      $[29] = t4;
    } else {
      t4 = $[29];
    }
    let t5;
    if ($[30] !== t4) {
      t5 = <h1 className="type-h2">{t4}</h1>;
      $[30] = t4;
      $[31] = t5;
    } else {
      t5 = $[31];
    }
    let t6;
    if ($[32] !== t) {
      t6 = t("notifications.unavailableHint");
      $[32] = t;
      $[33] = t6;
    } else {
      t6 = $[33];
    }
    let t7;
    if ($[34] !== t6) {
      t7 = <p className="mt-1 type-body2 text-osmix-text-2">{t6}</p>;
      $[34] = t6;
      $[35] = t7;
    } else {
      t7 = $[35];
    }
    let t8;
    if ($[36] !== t5 || $[37] !== t7) {
      t8 = <div>{t5}{t7}</div>;
      $[36] = t5;
      $[37] = t7;
      $[38] = t8;
    } else {
      t8 = $[38];
    }
    let t9;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <ArrowLeft className="size-4" aria-hidden="true" />;
      $[39] = t9;
    } else {
      t9 = $[39];
    }
    let t10;
    if ($[40] !== t) {
      t10 = t("notifications.back");
      $[40] = t;
      $[41] = t10;
    } else {
      t10 = $[41];
    }
    let t11;
    if ($[42] !== t10) {
      t11 = <Button variant="osmix-outline" size="pill" asChild={true}><Link to="/notifications">{t9}{t10}</Link></Button>;
      $[42] = t10;
      $[43] = t11;
    } else {
      t11 = $[43];
    }
    let t12;
    if ($[44] !== t11 || $[45] !== t8) {
      t12 = <div className="mx-auto flex min-h-64 max-w-2xl flex-col items-center justify-center gap-4 rounded-3xl bg-osmix-gray-100 p-8 text-center">{t3}{t8}{t11}</div>;
      $[44] = t11;
      $[45] = t8;
      $[46] = t12;
    } else {
      t12 = $[46];
    }
    return t12;
  }
  const item = detail.data;
  let t3;
  if ($[47] !== item.action) {
    t3 = resolveBuyerNotificationAction(item.action);
    $[47] = item.action;
    $[48] = t3;
  } else {
    t3 = $[48];
  }
  const actionHref = t3;
  let t4;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ArrowLeft className="size-4" aria-hidden="true" />;
    $[49] = t4;
  } else {
    t4 = $[49];
  }
  let t5;
  if ($[50] !== t) {
    t5 = t("notifications.back");
    $[50] = t;
    $[51] = t5;
  } else {
    t5 = $[51];
  }
  let t6;
  if ($[52] !== t5) {
    t6 = <Link to="/notifications" className="inline-flex min-h-11 items-center gap-2 self-start rounded-full type-body2 text-osmix-tangelo hover:underline">{t4}{t5}</Link>;
    $[52] = t5;
    $[53] = t6;
  } else {
    t6 = $[53];
  }
  const t7 = `notifications.kinds.${item.kind === "purchase_receipt" ? "receipt" : item.kind === "post_purchase_follow_up" ? "followUp" : "information"}`;
  let t8;
  if ($[54] !== t || $[55] !== t7) {
    t8 = t(t7);
    $[54] = t;
    $[55] = t7;
    $[56] = t8;
  } else {
    t8 = $[56];
  }
  let t9;
  if ($[57] !== t8) {
    t9 = <span className="font-bold text-osmix-text-2">{t8}</span>;
    $[57] = t8;
    $[58] = t9;
  } else {
    t9 = $[58];
  }
  let t10;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span aria-hidden="true">•</span>;
    $[59] = t10;
  } else {
    t10 = $[59];
  }
  const t11 = item.createdAt;
  let t12;
  if ($[60] !== item.createdAt) {
    t12 = new Date(item.createdAt).toLocaleString();
    $[60] = item.createdAt;
    $[61] = t12;
  } else {
    t12 = $[61];
  }
  let t13;
  if ($[62] !== item.createdAt || $[63] !== t12) {
    t13 = <time dateTime={t11}>{t12}</time>;
    $[62] = item.createdAt;
    $[63] = t12;
    $[64] = t13;
  } else {
    t13 = $[64];
  }
  let t14;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span aria-hidden="true">•</span>;
    $[65] = t14;
  } else {
    t14 = $[65];
  }
  const t15 = item.readAt ? "notifications.read" : "notifications.unread";
  let t16;
  if ($[66] !== t || $[67] !== t15) {
    t16 = t(t15);
    $[66] = t;
    $[67] = t15;
    $[68] = t16;
  } else {
    t16 = $[68];
  }
  let t17;
  if ($[69] !== t16) {
    t17 = <span>{t16}</span>;
    $[69] = t16;
    $[70] = t17;
  } else {
    t17 = $[70];
  }
  let t18;
  if ($[71] !== t13 || $[72] !== t17 || $[73] !== t9) {
    t18 = <div className="flex flex-wrap items-center gap-2 type-small text-osmix-icon">{t9}{t10}{t13}{t14}{t17}</div>;
    $[71] = t13;
    $[72] = t17;
    $[73] = t9;
    $[74] = t18;
  } else {
    t18 = $[74];
  }
  let t19;
  if ($[75] !== item.title) {
    t19 = <h1 className="mt-4 type-h1-bold text-osmix-text-1">{item.title}</h1>;
    $[75] = item.title;
    $[76] = t19;
  } else {
    t19 = $[76];
  }
  let t20;
  if ($[77] !== t18 || $[78] !== t19) {
    t20 = <header>{t18}{t19}</header>;
    $[77] = t18;
    $[78] = t19;
    $[79] = t20;
  } else {
    t20 = $[79];
  }
  let t21;
  if ($[80] !== item.body) {
    t21 = <p className="whitespace-pre-line type-body1 leading-7 text-osmix-text-2">{item.body}</p>;
    $[80] = item.body;
    $[81] = t21;
  } else {
    t21 = $[81];
  }
  let t22;
  if ($[82] !== actionHref || $[83] !== item.action || $[84] !== t) {
    t22 = actionHref && item.action && <Button variant="osmix-filled" size="pill" className="self-start" asChild={true}><Link to={actionHref}>{t(`notifications.actions.${item.action.kind}`)}</Link></Button>;
    $[82] = actionHref;
    $[83] = item.action;
    $[84] = t;
    $[85] = t22;
  } else {
    t22 = $[85];
  }
  let t23;
  if ($[86] !== t20 || $[87] !== t21 || $[88] !== t22 || $[89] !== t6) {
    t23 = <article className="mx-auto flex max-w-3xl flex-col gap-6 rounded-3xl bg-card p-6 shadow-block sm:p-8">{t6}{t20}{t21}{t22}</article>;
    $[86] = t20;
    $[87] = t21;
    $[88] = t22;
    $[89] = t6;
    $[90] = t23;
  } else {
    t23 = $[90];
  }
  return t23;
}
function _temp2(state_0) {
  return state_0.token;
}
function _temp(state) {
  return state.user;
}